// Whether a feature flag can be switched on, shared by the flag list and the
// configuration dialog so the badge and the dialog can never disagree.
//
// A required field is satisfied by a value typed now or by one already stored: a secret
// never reaches the browser, so `configured` is the only signal the form has for it.
export const isFieldMissing = (field, values) =>
  field.required && !values[field.key] && !field.configured;

export const isFeaturePending = (feature, values) =>
  feature.config.some(field => isFieldMissing(field, values));
